<template>
  <div class="year-main-content">
    <div class="year-top-image" v-bind:style="{ backgroundImage: 'url(' + require('@/assets/' + topImage) + ')' }">
    <div class="year-overlay"><span>2004</span></div>
    </div>
    <div class="view-wrap yr2004">


<FullYearStats fullGames='15' fullCompletions='262' fullAttempts='400' fullYards='3,159' fullPct='65.5' fullTDs='27' fullINTs='7' fullYPG='210.6' fullRating='104.8'></FullYearStats>

  <div class="year-summary-wrapper">
    <div class="triangle-top-left"></div>
    <div class="triangle-bottom-right"></div>
    <div class="year-summary">
    
      <div class="year-summary-text-flex">


<h1 class="content-headline">Amid Controversy, Brees has a breakout season...</h1>

      <div class="copy-paragraph">With the expectations after the Chargers' 8-8 2002 season largely dispelled by a lackluster 4-12 campaign in 2003, the San Diego front office decided to make a play for a quarterback as they held the 1st pick in the 2004 NFL draft.<br/><br/>

      A bizarre draft day swap of quarterbacks saw San Diego's 1st overall pick Eli Manning shipped away to the New York Giants in exchange for their 4th overall pick, NC State's Phillip Rivers.<br/><br/>

      Unfazed, Drew had the best season of his young career, completing 65.5% of his passes with 27 touchdowns while throwing only 7 interceptions.<br/><br/>

      He would lead the Chargers to a 12-4 season and their first playoff appearance in nine years, winning the AFC West for the first time since 1994.<br/><br/>
      </div>

      <div class="copy-paragraph">
      <img :src="require('@/assets/brees-2004-img-in-copy.jpg')" alt="Drew Brees raising hands after touchdown" style="width:100%;">
      </div>

      <div class="awards-wrapper">
        <div class="awards-headline">2004 Awards</div>
        <ul>

          <li><img :src="require('@/assets/pro-bowl.png')" alt="Pro Bowl Logo"> 2004 Pro Bowl</li>
          <li><img :src="require('@/assets/ap-award.jpg')" alt="AP Logo"> Comeback Player of the Year</li>
          <li><img :src="require('@/assets/nfl-logo.svg')" alt="NFL Logo"> 2nd Team All-Pro (CN, FD)</li>
          <li><img :src="require('@/assets/nfl-logo.svg')" alt="NFL Logo"> Most Improved Player (PFW, SI)</li>
          
        </ul>
        <div class="awards-legend">
<b>AP</b> - Associated Press, <b>CN</b> - College & Pro Football Weekly, <b>FD</b> -Football Digest, <b>FN</b> -Football News, <b>FW</b> - Professional Football Writers of America, <b>NE</b> - Newspaper Enterprise Association, <b>NY</b> - New York Daily News, <b>PFWA</b> - Pro Football Writers of America, <b>PW</b> - Pro Football Weekly(1992-2012,choices combined with Pro Football Writers of America), <b>SI</b> - Sports Illustrated, <b>SN</b> - Sporting News, <b>UP</b> - United Press International, <b>UW</b> - USA Today/Sports Weekly
        </div>
      </div> 





      </div> <!--end text-flex-->
    </div>
  </div>


   <div class="bubble-chart-wrapper chart-light">
      <h2 class="chart-headline">2004 Top Rated Passers</h2>
      <BubbleChart :chart-data="dataBubble1" :options="dataOptions3" style="height:400px;"></BubbleChart>
    </div>





<div class="touchdowns-header-wrapper">
  <h1><img src="https://nolaprodigital.com/saints/brees500/images/referee-icon-white.png" alt="Drew Brees 2004 Touchdown Tally"> 2004 TOUCHDOWN TALLY</h1>
</div>




</div>


<TDsByYear :tds="this.tds"></TDsByYear>



<flickity ref="flickity" :options="flickityOptions">
  <div class="carousel-cell"><img :src="require('@/assets/' + image1)" alt="Drew Brees in 2004 - Slide1"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image2)" alt="Drew Brees in 2004 - Slide2"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image3)" alt="Drew Brees in 2004 - Slide3"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image4)" alt="Drew Brees in 2004 - Slide4"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image5)" alt="Drew Brees in 2004 - Slide5"></div>
</flickity>


<div class="year-pagination-wrapper">
  <div class="year-pagination-section year-pagination-prev"><router-link to="/year/2003">«2003</router-link></div>
  <div class="year-pagination-section year-pagination-current">2004</div>
  <div class="year-pagination-section year-pagination-next"><router-link to="/year/2005">2005»</router-link></div>
</div>



    </div>
  </div>
</template>


<script>
// @ is an alias to /src
import StatsFlex from '@/components/StatsFlex.vue'
import Flickity from 'vue-flickity';
import VideoBtn from '@/components/VideoBtn.vue';
import FullYearStats from '@/components/FullYearStats.vue';
import TDsByYear from '@/components/TDsByYear.vue';
import BubbleChart from '@/components/BubbleChart.vue'

import axios from 'axios';

export default {
  name: 'yr2004',
  components: {
    Flickity,
    StatsFlex,
    VideoBtn,
    FullYearStats,
    TDsByYear,
    BubbleChart
  },
  metaInfo: {
    title: 'Drew Brees Stats and Touchdowns from his 2004 season',
    htmlAttrs: {
      lang: 'en'
    }
  },
  data() {
    return {
      dataCollection: {},
      dataOptions:{},
      tds: {},
      loading: false,
      games: [],
      topImage: "brees-2004-top.jpg",
      image1: "brees-2004-slide-1.jpg",
      image2: "brees-2004-slide-2.jpg",
      image3: "brees-2004-slide-3.jpg",
      image4: "brees-2004-slide-4.jpg",
      image5: "brees-2004-slide-5.jpg",

      flickityOptions: {
            initialIndex: 0,
            prevNextButtons: false,
            pageDots: false,
            resize: true,
            wrapAround: true,
            autoPlay: true

            // any options from Flickity can be used
            }

          } 
        },
  methods: {
    async getTDs() {
      const self = this;
      const response = await axios.get(
        "../../static/td-data.json"
      );
      this.tds = response.data.y2004;
      console.log(this.tds)
    },
    next() {
      this.$refs.flickity.next();
    },

    previous() {
      this.$refs.flickity.previous();
    },
    resize() {
      this.$refs.flickity.resize();
    }
  },

  mounted: function() {
    this.getTDs();

    setTimeout(() => {
    this.$refs.flickity.resize();
    }, 2000)

},
created() {

      

       this.dataBubble1 = {
      "datasets": [
      {
        "label": "Drew Brees",
        "backgroundColor": "#101820",
        "borderColor": "#D3BC8D",
        "fill": false,
        "pointBackgroundColor": '#D3BC8D',
        "pointColor": "#D3BC8D",
        
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#D3BC8D",
        data: [
                {
                  x: 104.8,
                  y: 8.5,
                  r: 6.8*2
                }
              ]
      },
      {
        "label": "Peyton Manning",
        "backgroundColor": "#fff",
        "borderColor": "#002C5F",
        "fill": false,
        radius: 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 121.1,
                  y: 10.2,
                  r: 9.9*2
                }
              ]
      },
      {
        "label": "Duante Culpepper",
        "backgroundColor": "#4F2683",
        "borderColor": "#FFC62F",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 110.9,
                  y: 9.1,
                  r: 7.1*2
                }
              ]
      },
      {
        "label": "Donovan McNabb",
        "backgroundColor": "#004C54",
        "borderColor": "#A5ACAF",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 104.7,
                  y: 8.8,
                  r: 6.6*2
                }
              ]
      },
      {
        "label": "Ben Roethlisberger",
        "backgroundColor": "#101820",
        "borderColor": "#FFB612",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 98.1,
                  y: 8.4,
                  r: 5.8*2
                }
              ]
      }
      ]
    },
    this.dataOptions3 = {
        "responsive": true,
        "maintainAspectRatio": false,
        title: {
            display: true,
            text: '(Bubble size is the % of TDs thrown when attempting to pass)'
        },
        "layout": {
          padding: {
                left: 10,
                right: 10,
                top: 0,
                bottom: 0
          },
        },
        "legend": {
          "position" : "bottom",
            "maxSize" : {
                "height" : 400
            },
            "labels": {
                "fontColor": "black",
                "fontSize": 14,
                "usePointStyle" : true
            }
        },
        tooltips: {
          "mode": "point",
          callbacks: {
              label: function(tooltipItem, data) {
                 var rLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].r;
                  var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
                  return datasetLabel + ' : ' + tooltipItem.yLabel.toLocaleString() + ' AY/A, ' + tooltipItem.xLabel.toLocaleString() + ' QB Rating, ' + rLabel/2 + ' TD %';
              }
          }
        },
        "scales": {
          "yAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Adjusted Yards Gained Per Attempt'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
                },
            "ticks": {
              "fontColor": 'black',
              callback: function(value, index, values) {
                        return value.toLocaleString();
                    },
            },
          }],
          "xAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'QB Rating'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
            },
            "ticks": {
              
              "fontColor": 'black'
            },
          }]
        }
    }

    }
}
</script>

<style>




</style>


// WEBPACK FOOTER //
// src/views/yr2004.vue